import { z } from 'zod'
import { AuftragX_25Schema, AuftragX_95Schema } from '../../Auftraege'

// Default constants
const DEFAULT_AUFTRAG_2_10 = {
  enabled: false
}

const DEFAULT_BEFEHL_2_FORM = {
  auftrag_2_10: DEFAULT_AUFTRAG_2_10,
  auftrag_2_25: {
    enabled: false
  },
  auftrag_2_95: {
    enabled: false,
    freitext: ''
  }
}

// Schema definitions
const Auftrag2_10Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_2_10.enabled)
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_2_10))

// Base schema
const Befehl2FormSchemaBase = z
  .object({
    // Auftrag 2.10
    auftrag_2_10: Auftrag2_10Schema,

    // Auftrag 2.25
    auftrag_2_25: AuftragX_25Schema,

    // Auftrag 2.95
    auftrag_2_95: AuftragX_95Schema
  })
  .default(() => structuredClone(DEFAULT_BEFEHL_2_FORM))

export const Befehl2FormSchema = Befehl2FormSchemaBase

// Validation schema factory
export const createBefehl2FormValidationSchema = () => {
  return Befehl2FormSchemaBase
}

export type Befehl2FormData = z.infer<typeof Befehl2FormSchemaBase>
